// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"yq-z","imageAndVideoCount":"zq-z","imageAndVideoContainer":"Aq-z","viewAllReviews":"Bq-z"};